module.exports = __webpack_public_path__ + "static/media/service.3278b9a3.jpg";